export default "__VITE_ASSET__B1SP36gm__"